import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reassurance } from './Reassurance';
import { HERO_IMAGE } from '../data/content';
const puntos = ['Menos improvisación y restricciones extremas', 'Más control sobre hambre y antojos', 'Hábitos que acompañan tu energía y bienestar', 'Un protocolo claro para saber qué hacer cada día'];
export function Hero() {
  return <section className="w-full bg-white px-4 pb-10 pt-10 sm:px-6 sm:pt-14" data-id="element-64" data-mp="128607wumu8qj">
      <div className="mx-auto max-w-4xl text-center" data-id="element-65" data-mp="x9un9d91ji43">
        <h1 className="font-display text-3xl font-extrabold leading-[1.1] tracking-tight text-brand-deep sm:text-5xl lg:text-[3.4rem]" data-id="element-66" data-mp="x8b7rov7lb3d">
          Antes de volver a hacer dieta, hacé un{' '}
          <span className="text-brand" data-id="element-67" data-mp="nbyir4alzley">RESET</span>.
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-[0.95rem] leading-relaxed text-gray-600 sm:text-lg" data-id="element-68" data-mp="3d2labedjz91r">
          Si sentís que comés menos, intentás cuidarte y aun así volvés a los
          antojos, la hinchazón y la falta de energía, seguir exigiéndote más
          puede no ser la respuesta.
        </p>

        <div className="mt-8" data-id="element-69" data-mp="3o6apvvoqw6zy">
          <img src={HERO_IMAGE} alt="Los 6 tomos de la Enciclopedia del Reinicio Metabólico junto a la app en tablet y móvil" className="mx-auto w-full max-w-3xl" width={1536} height={1024} data-id="element-70" data-mp="3o5j2v997rhla" />
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-[0.95rem] leading-relaxed text-gray-700 sm:text-lg" data-id="element-71" data-mp="30gge7hg5woha">
          El <strong className="font-semibold text-brand" data-id="element-72" data-mp="35a2gcfop99yu">Reset Metabólico</strong>{' '}
          es un protocolo práctico diseñado para ayudarte a reorganizar
          alimentación, horarios y hábitos que influyen en cómo te sentís cada
          día.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-[0.95rem] leading-relaxed text-gray-700 sm:text-lg" data-id="element-73" data-mp="2hix03zeukfo0">
          La idea es simple: dejar de improvisar, recuperar el control y crear
          las condiciones para que tu cuerpo vuelva a responder a tus esfuerzos.
        </p>

        <ul className="mx-auto mt-7 grid max-w-2xl gap-2 text-left sm:grid-cols-2 sm:gap-3" data-id="element-74" data-mp="nbl4gqm0mqd3">
          {puntos.map(punto => <li key={punto} className="flex items-start gap-2 rounded-xl bg-brand-soft px-3.5 py-3 text-[0.9rem] leading-snug text-gray-700 sm:text-base" data-id="element-75" data-mp="id9vei3jojvx">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-76" data-mp="1azul7e4dgnxd" />
              {punto}
            </li>)}
        </ul>

        <p className="mt-8 font-display text-xl font-extrabold uppercase leading-tight text-brand-deep sm:text-3xl" data-id="element-77" data-mp="111okv0y7rpum">
          No necesitás otra dieta.{' '}
          <span className="text-accent" data-id="element-78" data-mp="3lsysay1o8kij">Necesitás un RESET.</span>
        </p>

        <div className="mx-auto mt-7 max-w-md" data-id="element-79" data-mp="3lquenodz0752">
          <CtaButton href="#precio" location="hero" data-id="element-80" data-mp="3hr3sxz3awh7e">
            Quiero mi acceso hoy
          </CtaButton>
          <Reassurance className="mt-3" items={['Acceso inmediato', '100% digital', 'Un solo pago', 'Sin suscripciones']} data-id="element-81" data-mp="1xacfj35u5jt8" />
        </div>
      </div>
    </section>;
}